export function CookiePolicy() {
  return (
    <div className="row center-contact ">
      <div className="col-10">
        <h1 className="header-sub-page">Cookie Policy</h1>
        <h2>Last updated: March 11th, 2020</h2>
        WHY? Record Company (WRC) / whyrecord.com (“us”, “we”, or “our”) uses
        cookies on the{" "}
        <a href="https://whyrecord.com/">https://whyrecord.com/</a> website (the
        “Service”). By using the Service, you consent to the use of cookies. Our
        Cookies Policy explains what cookies are, how we use cookies, how
        third-parties we may partner with may use cookies on the Service, your
        choices regarding cookies and further information about cookies.
        <h3>What are cookies?</h3>
        <p>
          Cookies are small pieces of text sent to your web browser by a website
          you visit. A cookie file is stored in your web browser and allows the
          Service or a third-party to recognize you and make your next visit
          easier and the Service more useful to you. Cookies can be “persistent”
          or “session” cookies. Persistent cookies remain on your personal
          computer or mobile device when you go offline, while session cookies
          are deleted as soon as you close your web browser.
        </p>
        <h3>How we use cookies</h3>
        <p>
          When you use and access the Service, we may place a number of cookies
          files in your web browser.
        </p>
        <p>
          We use cookies for the following purposes:
          <ul className="list-unstyled">
            <li>To enable certain functions of the Service</li>
            <li>To provide analytics</li>
          </ul>
          We use both session and persistent cookies on the Service and we use
          different types of cookies to run the Service:
          <ul className="list-unstyled">
            <li>
              Essential cookies. We may use essential cookies to authenticate
              users and prevent fraudulent use of user accounts.
            </li>
            <li>
              Analytics cookies. We may use analytics cookies to track
              information how the Service is used so that we can make
              improvements. We may also use analytics cookies to test new
              advertisements, pages, features or new functionality of the
              Service to see how our users react to them.
            </li>
            <li>
              Third-party cookies. In addition to our own cookies, we may also
              use various third-parties cookies to report usage statistics of
              the Service, deliver advertisements on and through the Service,
              and so on.
            </li>
          </ul>
        </p>
        <h2>What are your choices regarding cookies?</h2>
        <p>
          If you’d like to delete cookies or instruct your web browser to delete
          or refuse cookies, please visit the help pages of your web browser.
          Please note, however, that if you delete cookies or refuse to accept
          them, you might not be able to use all of the features we offer, you
          may not be able to store your preferences, and some of our pages might
          not display properly.
        </p>
        <p>
          For the Chrome web browser, please visit this page from Google:{" "}
          <a href="https://support.google.com/accounts/answer/32050">
            https://support.google.com/accounts/answer/32050
          </a>
        </p>
        <p>
          For the Internet Explorer web browser, please visit this page from
          Microsoft:{" "}
          <a href="http://support.microsoft.com/kb/278835">
            http://support.microsoft.com/kb/278835
          </a>
        </p>
        <p>
          For the Firefox web browser, please visit this page from Mozilla:{" "}
          <a href="https://support.mozilla.org/en-US/kb/delete-cookies-remove-info-websites-stored">
            https://support.mozilla.org/en-US/kb/delete-cookies-remove-info-websites-stored
          </a>
        </p>
        <p>
          For the Safari web browser, please visit this page from Apple:{" "}
          <a href="https://support.apple.com/kb/PH21411?locale=en_US">
            https://support.apple.com/kb/PH21411?locale=en_US
          </a>
        </p>
        <p>
          For any other web browser, please visit your web browser’s official
          web pages.
        </p>
        <h3>Where can you find more information about cookies?</h3>
        <p>
          You can learn more about cookies and the following third-party
          websites:
          <ul className="list-unstyled">
            <li>
              AllAboutCookies:{" "}
              <a href="http://www.allaboutcookies.org/">
                http://www.allaboutcookies.org/
              </a>
            </li>
            <li>
              Network Advertising Initiative:{" "}
              <a href="http://www.networkadvertising.org/">
                http://www.networkadvertising.org/
              </a>
            </li>
          </ul>
        </p>
        <h3>What are your choices regarding annoying cookie banners?</h3>
        <p>
          You can get rid of annoying cookie banners on many sites by using a
          browser addon to automatically accept cookies:
          <ul className="list-unstyled">
            <li>
              I Don’t Care About Cookies:{" "}
              <a href="https://www.i-dont-care-about-cookies.eu/">
                https://www.i-dont-care-about-cookies.eu/
              </a>
            </li>
            <li>
              CookiesOK:{" "}
              <a href="https://cookiesok.com/">https://cookiesok.com/</a>
            </li>
          </ul>
        </p>
      </div>
    </div>
  );
}
